import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { renderAnnouncementHtml } from "../utils/announcements";

const modalIcon = "mdi-bulletin-board";

const AnnouncementDetailModal = ({ isOpen, toggle, announcement }) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-lg">
      <ModalHeader toggle={toggle} className="pb-2">
        {announcement?.title || t("announcements.view.modal.defaultTitle")}
      </ModalHeader>
      <ModalBody>
        <div className="d-flex align-items-center mb-3">
          <span
            className="d-inline-flex align-items-center justify-content-center rounded-circle mr-2"
            style={{
              width: "32px",
              height: "32px",
              backgroundColor: "primary",
            }}
          >
            <i className={`mdi ${modalIcon}`} />
          </span>
          <span>
            {announcement?.created && (
              <small className="text-muted">
                {new Date(announcement.created).toLocaleString()}
              </small>
            )}
          </span>
        </div>
        <div
          className="text-dark"
          style={{ wordBreak: "break-word", lineHeight: "1.5" }}
          dangerouslySetInnerHTML={renderAnnouncementHtml(announcement?.body)}
        />
      </ModalBody>
    </Modal>
  );
};

export default AnnouncementDetailModal;
